import useAuth from "features/auth/useAuth";
import React, { cloneElement } from "react";

interface PermissionProps {
  acceptableClaims?: string[];
  children: any;
}

export const Permission: React.FC<PermissionProps> = ({
  acceptableClaims,
  children,
  ...rest
}) => {
  const { hasClaim } = useAuth();

  if (acceptableClaims && !hasClaim(acceptableClaims)) {
    return null;
  }

  return Array.isArray(children) && children.length >= 2
    ? React.Children.map(children, (child) => {
        return React.cloneElement(child, { rest }, null);
      })
    : cloneElement(children, rest);
};
